export default __webpack_public_path__ + "static/media/serviceImgEngagement.382e2429.svg";